import React from "react";

function ButtonGroup({
  backStepNav,
  optimizeMyUniverseHandler,
  navToDashboard,
  nextStepCallBack,
}) {
  return (
    <div className="addbtn-group">
      <div>
        <button className="btn btn-db" onClick={() => backStepNav()}>
          <i className="fa fa-angle-left" /> Back
        </button>
      </div>
      <div>
        <button
          className="btn btn-db"
          onClick={() => optimizeMyUniverseHandler()}
          // disabled={
          //   this.state.responseId === 0 || ErrorLoadingData === true
          //     ? true
          //     : false
          // }
        >
          Optimize using my universe <i className="fa fa-angle-right" />
        </button>
        {/* <button
          className="btn btn-db"
          onClick={() => navToDashboard()}
          // disabled={
          //   this.state.responseId === 0 || ErrorLoadingData === true
          //     ? true
          //     : false
          // }
        >
          View Performance Details <i className="fa fa-angle-right" />
        </button> 
        <button
            className="btn btn-db"
            disabled={
              active_optimize_using_myUniverse === false ? true : false
            }
            onClick={() => nextStepCallBack(true)}
          >
            Next
            <i className="fa fa-angle-right" />
          </button> */}
      </div>
    </div>
  );
}

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/buttonGroup/ButtonGroup.jsx